import { CustomIcon } from '@space-shell/modules/communities/communityConfigurationSidebar/styles'
import styled from 'styled-components'

export const WarningAlert = styled.div`
  background-color: var(--yellow-lightest);
`

WarningAlert.displayName = 'WarningAlert'

export const WarningLabel = styled.p`
  color: var(--yellow-darker);
`

WarningLabel.displayName = 'WarningLabel'

export const WarningIcon = styled(CustomIcon)`
  color: var(--yellow-darkest);
  width: 1rem;
  height: 1rem;
`

WarningIcon.displayName = 'WarningIcon'
